var React = require('react');
var helpers = require('svg-react-loader/helpers')(require('react-dom'));

module.exports = React.createClass({

    displayName: "ImageUploadMultiple",

    getDefaultProps () {
        return {"xmlns":"http://www.w3.org/2000/svg","className":"dibsvg-svg dibsvg-img-upload-multiple","viewBox":"0 0 250 250"};
    },

    componentDidMount () {
        helpers.applyXmlAttributes(this);
    },

    render () {
        var props = this.props;
        var children = props.children;

        return (
            <svg {...this.props}>
                  <polygon points="131,17.2 131,137 140,137 140,16.6 186.6,58.8 192.6,52.1 135.4,0.3 82.2,52.2 88.5,58.7"/>
  <path d="M155 94v9h65v97.2l-63.9-49.7-46.9 38.8L97 178.7 52 212V103h64v-9H43v34H22v122h166v-21h41V94h-74zm24 147H31V137h12v92h136v12zm41-21H56.3l40.3-29.8 12.5 10.9 47.2-39 63.7 49.5v8.4z"/>
  <path d="M65.8 138.7c0 11.5 9.3 20.8 20.8 20.8s20.8-9.3 20.8-20.8-9.3-20.8-20.8-20.8-20.8 9.3-20.8 20.8zm32.6 0c0 6.5-5.3 11.8-11.8 11.8s-11.8-5.3-11.8-11.8 5.3-11.8 11.8-11.8c6.5 0 11.8 5.3 11.8 11.8z"/>
                {React.Children.map(children, (c) => (c))}
            </svg>
        );
    }
});



// WEBPACK FOOTER //
// ./src/image-upload-multiple.svg